module.exports = __webpack_public_path__ + "img/hej-th.097abe7d.png";